<template>
    <div>
        <div class="nav-vertical">
			<ul class="nav nav-tabs nav-left" role="tablist">
                <li class="nav-item">
                  <a class="nav-link active" v-bind:href="'#t1'+rowData.receita_id+''" role="tab" data-toggle="tab" >
                    <span class="nav-link-in">
                      Detalhes
                      <i class="fa fa-plus"></i>
                    </span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" v-bind:href="'#t2'+rowData.receita_id+''" v-if="rowData.receita_pagto.length>0" role="tab" data-toggle="tab" >
                    <span class="nav-link-in">
                      Pagamento
                      <i class="fa fa-money"></i>
                    </span>
                  </a>
                </li>
			</ul>

            <div class="tab-content">
                <div role="tabpanel" class="tab-pane fade in active show" v-bind:id="'t1'+rowData.receita_id+''">
                    <table class="table" id="mais">
                        <thead>
                          <tr>
                              <th style="width: 15%">Data Competencia</th>
                              <th style="width: 15%">Data Prevista</th>
                              <th style="width: 15%">Número DOC</th>
                              <th style="width: 55%">Observação</th>
                          </tr>
                         </thead>
                         <tbody>
                           <tr class="bg-gray-light" style="display: table-row;">
                              <td>
                                  {{ formatDate(rowData.dt_competencia) }}
                              </td>
                              <td>
                                  {{ formatDate(rowData.dt_vencto) }}
                              </td>
                              <td>
                                  {{ rowData.num_doc }}
                              </td>
                              <td>
                                  {{ rowData.obs }}
                              </td>
                          </tr>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
                <div role="tabpanel" class="tab-pane fade" v-bind:id="'t2'+rowData.receita_id+''">
                    <table class="table" id="mais">
                        <thead>
                            <tr>
                                <th style="width: 5%">Valor</th>
                                <th style="width: 5%">Desconto</th>
                                <th style="width: 5%">Juros</th>
                                <th style="width: 10%">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                           <template v-for="item in rowData.receita_pagto">
                             <tr class="bg-gray-light" style="display: table-row;">
                                <td>
                                    {{ formatNumber(item.vlr_pagto) }}
                                </td>
                                <td>
                                    {{ formatNumber(item.desconto) }}
                                </td>
                                <td>
                                    {{ formatNumber(item.juros) }}
                                </td>
                                <td>
                                    {{ item.status.descr }}
                                </td>
                            </tr>
                          </template>
                        </tbody>
                    </table>
                </div><!--.tab-pane-->
			</div><!--.tab-content-->
		</div>
    </div>
</template>

<script>
import { formatCNPJFromParts } from "../utils";

  import accounting from 'accounting'
  import moment from 'moment'

  export default {
      data () {
        return {
            visibleDetailRows: [],
            helpForm: new Form({statusRecord: [], params: []}),
        }
    },
    props: {
      rowData: {
        type: Object,
        required: true
      },
      rowIndex: {
        type: Number
      }
    },
    methods: {
      isVisibleDetailRow (rowId) {
        return this.visibleDetailRows.indexOf( rowId ) >= 0
      },
      showDetailRow (rowId) {
        if (!this.isVisibleDetailRow(rowId)) {
          this.visibleDetailRows.push(rowId)
        }
      },
      hideDetailRow (rowId) {
        if (this.isVisibleDetailRow(rowId)) {
          this.visibleDetailRows.splice(
            this.visibleDetailRows.indexOf(rowId),
            1
          )
        }
      },
      toggleDetailRow (rowId) {
        if (this.isVisibleDetailRow(rowId)) {
          this.hideDetailRow(rowId)
        } else {
          this.showDetailRow(rowId)
        }
      },
            onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
        return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
      },
      formatNumber (value) {
          return accounting.formatNumber(value, 2, '.', ',')
      },
      formatDate (value, fmt = 'DD/MM/YYYY') {
        return (value == null)
          ? ''
          : moment(value, 'YYYY-MM-DD').format(fmt)
      },
  },
}
  </script>